import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule, RouterOutlet } from '@angular/router';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { Constants } from '../../../../components/utils/constants'
import { HttpService } from '../../../../components/service/http.service';
import { BankProfile } from '../../../../components/utils/bank-profile';
import { BankAccountValidationRequest } from '../../../../components/utils/bank-account-validation-request';
import { BankDetailService } from '../../../../components/service/bank-detail.service';
import { SharedTranslateModule } from '../../../../utils/sharedTranslateModule';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { EditbankprofileComponent } from '../editbankprofile/editbankprofile.component';
import { PrintComponent } from '../print/print.component';
import { ProfileverificationComponent } from '../profileverification/profileverification.component';
import { RemovebankprofileComponent } from '../removebankprofile/removebankprofile.component';
import { PayCopyComponent } from '../../../pay copy/paycopy.component';
import { AuthorizationService } from '../../../../components/authorization/authorization.service';
import { WindowRef } from '../../../../utils/window';
import jsPDF from 'jspdf';
import autoTable, { RowInput } from 'jspdf-autotable';
import 'jspdf-autotable';
import { SessionTimeoutComponent } from './../../../../../../src/app/components/sessionTimeout/sessionTimeout.component';

export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'dtf-addbankprofile',
    templateUrl: './addbankprofile.component.html',
    imports: [SharedTranslateModule, MatTableModule, SessionTimeoutComponent,MatInputModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, RouterModule
    ]
})
export class AddbankprofileComponent implements OnInit {
  ADDPROFILETEXT = Constants.ADDPROFILETEXT;
  CORRECTINFORMATION = Constants.CORRECTINFORMATION;
  MANADATORYTEXT = Constants.MANADATORYTEXT;
  INVALIDROUTINGNUM = Constants.INVALIDROUTINGNUM
  EMAILVALIDATION = Constants.EMAILVALIDATION
  CONFIRMEMAILVALIDATION = Constants.CONFIRMEMAILVALIDATION
  INVALIDACCOUNTNUMBER = Constants.INVALIDACCOUNTNUMBER;
  INVALIDACCOUNTNUMBERPATTERN = Constants.INVALIDACCOUNTNUMBERPATTERN
  tabClicked: any;
  form!: UntypedFormGroup;
  submitted = false;
  bankRoutingNumber!: number;
  bankName!: string;
  bankAccountNumber!: number;
  nameOnBankAccount!: string;
  emailAddress!: string;
  confirmEmailAddress!: string;
  acccountType: any;
  invalid: boolean = false
  inValidBankRoutingNum: boolean = false;
  continue: boolean = false;
  bankDetails: any;
  invalidEmail: boolean = false;
  invalidConfirmEmail: boolean = false;
  routingNumber: string;
  addBankProfile: BankProfile = new BankProfile();
  validateBankProfile: BankAccountValidationRequest = new BankAccountValidationRequest;
  status!: String;
  invalidAccountNumber: boolean;
  consecutiveNum: boolean;
  correctInfo: boolean;
  errorArr: any={};
  userAccountInfo= sessionStorage.getItem('userAccountInfo')
  errmsg: any;
  blocked: boolean;
  loaded: boolean;
  rNum: String;
  step1 = true;
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;
  azURL: string;
  usUrl: string;
  savingProfile = false;
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  ciamId = sessionStorage.getItem('loginID');
  tableLoaded = false;
  agentView: boolean;
  beforestep2: boolean = false;
  pdf: boolean = false;
  agentview: string;
  errormsg: boolean = false;
  hide = false;

  

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: UntypedFormBuilder,
    private httpService: HttpService, public auth: AuthorizationService,private bankDetailService: BankDetailService, private _window: WindowRef) {
      this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
     }

  ngOnInit(): void {
    this.agentview = sessionStorage.getItem('agentview');
    // if(sessionStorage.getItem('agentView')=="true"){
    //   this.agentView=true
    // }else{
    //  this.agentView=false
    // }
    // this.activatedRoute.paramMap.subscribe((params: any) => {
    //   this.tabClicked = params.get("tabClicked"); //+ string to number

      this.setFormValue();
    // });

    this.form = this.formBuilder.group({
      routingNum: ['', Validators.required,],
      acctType: ['', Validators.required],
      bankName: ['', Validators.required],
      acctNum: ['', [Validators.required, Validators.minLength(4)]],
      nameOnBankAcct: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 ]+$/)]],
      email: ['', [Validators.required, Validators.email]],
      emailConfirm: ['', Validators.required],
      saveProfile: ['true'],
     


    })
    // this.addBankProfile.routingNum=this.form.routingNum;
  }

    changeType(input_field_password, num){
    if(input_field_password.type === 'password') {
      input_field_password.type = 'text';
    } else {
      input_field_password.type = 'password';
    }
    this.hide = !this.hide;
  }

  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
    
    if (this.selectedState === 1) {
      this.azURL =  this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 2) {
      this.azURL =  this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 3) {
      this.azURL =  this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 4) {
      this.azURL =  this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 6) {
      this.azURL =  this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 7) {
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 8) {
      this.azURL =  this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    } 
  }

  //  New Function

  getBankName() {
    this.rNum = this.form.controls['routingNum'].value;
    const request = {
     "routingNumber" : this.rNum
    }
    this.auth.getBankName(request).subscribe(res => {
      if(res == null || res.bank_name == null){
        this.form.controls['bankName'].setValue('');
      }else{
        this.form.controls['bankName'].setValue(res.bank_name);
      }

    }, error=>{
        if(error.status){
          this.errmsg=error.message
          this.blocked=true;
          this.loaded=true;
        }
  });
  }

  setFormValue() {
    this.bankDetailService.getObject.subscribe((data: any) => {
      if (data) {
        this.addBankProfile = data;
      }
    })

  }

  onSubmit() {
    this.submitted = true;
    this.invalid = false;
    this.correctInfo = false;
    this.invalidEmail = false;

    this.invalidConfirmEmail = false

    this.invalidAccountNumber = false;
    this.inValidBankRoutingNum= false;
    this.errorArr=[]

    this.consecutiveNum = false
    if (this.form.invalid) {
      this.correctInfo = true;
      let keys = Object.keys(this.form.value)
      keys.forEach(element => {
        if (!this.form['value'][element]) {
          this.invalid = true;
        }
      });
      let f = this.form.controls
      let key=Object.keys(f)
      keys.forEach(key => {
       if(f[key]['errors'] && f[key]['errors']['required']){
         this.errorArr[key]=true
       }

      })
      if (this.form.value.acctNum && f['acctNum']['errors']) {
        this.invalidAccountNumber = true;
      }
      if (this.form.value.bankName == "" && this.form.value.routingNum) {
        this.inValidBankRoutingNum = true;
      }
      if (f['email']['errors'] && f['email']['errors']['email']) {
        this.invalidEmail = true;
      }
      if (this.form.value.emailConfirm!="" && (this.form.value.email != this.form.value.emailConfirm)) {
        this.invalidConfirmEmail = true
      }

    }
    if (!this.invalidEmail && (this.form.value.email !== this.form.value.emailConfirm)) {
      this.invalidConfirmEmail = true
      this.correctInfo = true;
      this.continue = false;
    }
    else if (this.form.value.acctNum.length >= 4 && !this.form.invalid) {
      let boolValue = false
      let accountNumb = this.form.value.acctNum
      for (let i = 0; i < accountNumb.length - 1; i++) {
        if ((Number(accountNumb[i]) + 1) !== Number(accountNumb[i + 1])) {
          boolValue = true
          break;
        }
      }
      if (!boolValue) {
        this.consecutiveNum = true;
        this.continue = false;
        this.correctInfo = true;
      }
    }
    if (!this.invalidConfirmEmail && !this.consecutiveNum && !this.form.invalid) {
       this.invalidConfirmEmail = false
       this.invalid = false
       this.inValidBankRoutingNum = false
       this.invalidEmail = false;
      this.bankDetails = this.form.value;

      // this.addBankProfile.custLoginId="test5002104231001";

      this.validateBankProfile.routingNumber = this.form.value["routingNum"];
      this.validateBankProfile.accountNumber = this.form.value["acctNum"];

      this.addBankProfile.routingNum = this.form.value["routingNum"];
      this.addBankProfile.acctType = this.form.value["acctType"];
      this.addBankProfile.accountType= this.addBankProfile.acctType
      if (this.form.value["acctType"] == 'S') {
        this.addBankProfile.acctDescription = "SAVINGS";
      } else if (this.form.value["acctType"] == 'CC') {
        this.addBankProfile.acctDescription = "CORPORATE CHECKING";
      } else if (this.form.value["acctType"] == 'C') {
        this.addBankProfile.acctDescription = "CHECKING";
      }
      this.addBankProfile.bankName = this.form.value["bankName"];
      this.addBankProfile.acctNum = this.form.value["acctNum"];
      this.addBankProfile.nameOnBankAcct = this.form.value["nameOnBankAcct"];
      this.addBankProfile.email = this.form.value["email"];
      this.addBankProfile.emailConfirm = this.form.value["emailConfirm"];
      this.addBankProfile.bankAcctId = this.form.value["bankAcctId"];
      this.addBankProfile.saveProfile = this.form.value["saveProfile"];
    
      //  let obj=JSON.parse(this.userAccountInfo)
      //  this.addBankProfile.bankAcctCategory=obj.thirdPartyTypeCode
      // this.addBankProfile.dcsAccountNumber= obj.acctNumber;

      // if(obj.thirdPartyTypeCode=='B'){
      //   this.addBankProfile.bankAcctCategoryDesc="Business"
      // }else{
      //   this.addBankProfile.bankAcctCategoryDesc="Personal"
      // }
      // this.addBankProfile.custLoginId= obj.trkUserId;
      // this.addBankProfile.thirdPartyNum=obj.thirdpartyId;
      // this.addBankProfile.customerName=obj.custName
      
      //code to call validation service goes here

      this.status = "loading";
      const request = {
       "accountNumber": this.form.value["acctNum"],
        "routingNumber": this.form.value["routingNum"],
        type: this.form.value["acctType"] === 'C'
          ? 'CHECKING'
          : this.form.value["acctType"] === 'S'
            ? 'SAVINGS'
            : this.form.value["acctType"] === 'CC'
              ? 'CORPORATE_CHECKING'
              : ''
      }
       this.tableLoaded = false;
       this.auth.validateBank(request).subscribe(res => {
        this.status = res.status;
        // this.step1 = false;
        // this.continue = true;
      if(this.status == "SUCCESS"){
        this.step1 = false;
        this.continue = false;
        this.beforestep2 = true;
      }else{
        this.errormsg=true;
        this.beforestep2 = false;
      }
       }, error=>{
        this.status = ""
          if(error.status){
            this.errmsg=error.message
            this.blocked=true;
            this.loaded=true;
          }
     });
  }
 }

 onSubmitVerification(){
    this.savingProfile = true;
    if (!this.bankDetails.saveProfile) {
      this.savingProfile = false;
      sessionStorage.setItem('saveProfileFasleObj', JSON.stringify(this.bankDetails));
    }
    const request1 = {
      "email": this.form.value["email"],
      "bank_account_details": {
      "type": this.form.value["acctType"] === 'C'
          ? 'CHECKING'
          : this.form.value["acctType"] === 'S'
            ? 'SAVINGS'
            : this.form.value["acctType"] === 'CC'
              ? 'CORPORATE_CHECKING'
              : '',
        "account_number": this.form.value["acctNum"],
        "routing_number": this.form.value["routingNum"],
        "holder_name": this.form.value["nameOnBankAcct"],
        "bank_name": this.form.value["bankName"]
      },
      "alfa_customer_reference": this.thirdPartyNumber,
      "alfa_account_number": "",
      "temporary": !this.savingProfile,
      "social_security_number": "1496",
      "country_code": "US",
      "brand": "IDK",
      "language": "US",
      "prefill_bankinfo": "1",
      "bank_account_cat": "1",
      "customer_login_id": this.ciamId,
      "autopay_banking_profile_ind": "1",
       "nacha_values": {
                    "return_code": "somecode5",
                    "timestamp": "2022-01-01T00:00:00Z",
                    "status": "somestatus4",
                    "reference_id": "somerefrecne5"
                }
    }
    this.auth.saveProfile(request1).subscribe(res => {
    if(res){
      this.tableLoaded = true;
      this.step1 = false;
      this.beforestep2 = false;
      //this.status = "SUCCESS"
      if(res.temporary == true){
        sessionStorage.setItem('dtpaycustomerid', res.dtpay_customer_id);
        sessionStorage.setItem('dtpaypaymentmethodtoken', res.dtpay_payment_method_token);
        sessionStorage.setItem('dtpayMaskedAccountNumber', res.bank_account_details.masked_routing_number);
      }
      this.continue = true;  
      }
     });
    }

 downloadPDF() {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    var base64Img =
        'data:image/jpeg;base64,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';
      if (base64Img) {
        doc.addImage(base64Img, 'JPEG', pageWidth - 195, 15, 50, 10);
    }

    
    doc.setFontSize(20);
    doc.text('Manage Bank Profile', 105, 35, { align: 'center' });

    
    doc.setFontSize(12);
    doc.text(
      'Thank you for using the Online Payment Service. Your profile has been added.',
      20, 45
    );

    
    const rows = [
      ['Bank Name', String(this.addBankProfile.bankName)],
      ['Bank Account Type', String(this.addBankProfile.acctDescription)],
      ['Bank Account Number',  String(this.addBankProfile.acctNum).replace(/\d(?=\d{4})/g, 'x')],
      ['Bank Routing Number', String(this.addBankProfile.routingNum).replace(/\d(?=\d{4})/g, 'x')],
      ['Email Address', String(this.addBankProfile.email)]
    ];

  
    autoTable(doc, {
      startY: 60,
      body: rows,
      theme: 'plain',
      styles: { fontSize: 11, cellPadding: 3 },
      headStyles: { fillColor: [230, 230, 230], textColor: 0, fontStyle: 'bold' },
      columnStyles: {
        0: { cellWidth: 60, fontStyle: 'bold' },
        1: { cellWidth: 'auto' }
      }
    });

    doc.save('Saved Bank Profile.pdf');
  }

 Cancel(){
    this.form.reset();
    this.step1=true;
    this.continue=false;
    this.beforestep2 = false;
    this.status != "loading";
 }

  editEvent(event: any) {

    if (event == "true") {
      this.continue = false;
    }
  }

  back(){
    this.form.reset();
    this.status != "loading";
    this.step1 = true;
    this.continue = false;
  }

  Done(){
    if(this.bankDetails.saveProfile == true){
    this._window.nativeWindow.location.href = '/home/dashboard';
    }else{
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
  }
}
